// @ts-nocheck
import { getContentSearchDataView } from "@store/Framework/Store/Data/ContentSearch/ContentSearchSelectors";
import convertSelectorToHook from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

export const useContentSearchDataView = convertSelectorToHook(getContentSearchDataView);
